import React from "react"
import CookieConsent from "react-cookie-consent"
import {
  ANALYTICS_CONSENT_COOKIE,
  loadGoogleAnalytics,
  trackPageView,
} from "../utils/analytics"

const cardStyle = {
  background: "#ffffff",
  color: "#252525",
  left: "50%",
  right: "auto",
  bottom: "28px",
  transform: "translateX(-50%)",
  width: "min(92%, 460px)",
  padding: "26px 28px 22px",
  borderRadius: "18px",
  boxShadow: "0 24px 60px rgba(0, 0, 0, 0.28)",
  display: "flex",
  flexDirection: "column",
  alignItems: "stretch",
  gap: "6px",
  zIndex: 1000,
}

const overlayStyle = {
  background: "rgba(20, 18, 40, 0.55)",
  backdropFilter: "blur(2px)",
  zIndex: 999,
}

const contentStyle = {
  flex: "initial",
  margin: "0 0 18px",
  fontSize: "15px",
  lineHeight: 1.5,
}

const acceptButtonStyle = {
  display: "block",
  width: "100%",
  margin: "0",
  padding: "13px 18px",
  fontSize: "15px",
  fontWeight: 700,
  letterSpacing: "0.4px",
  color: "#ffffff",
  background: "linear-gradient(45deg, #ffc549, #ff6600, #ffc549)",
  border: 0,
  borderRadius: "12px",
  boxShadow: "0 10px 20px rgba(255, 122, 0, 0.28)",
  cursor: "pointer",
}

const declineButtonStyle = {
  display: "block",
  width: "100%",
  margin: "10px 0 0",
  padding: "6px 4px",
  fontSize: "13px",
  fontWeight: 500,
  color: "#818181",
  background: "transparent",
  border: 0,
  textDecoration: "underline",
  cursor: "pointer",
}

const headingStyle = {
  display: "block",
  margin: "0 0 8px",
  fontSize: "18px",
  fontWeight: 700,
}

const AnalyticsConsent = () => (
  <CookieConsent
    overlay
    location="bottom"
    buttonText="Accept & continue"
    declineButtonText="Not now"
    enableDeclineButton
    cookieName={ANALYTICS_CONSENT_COOKIE}
    style={cardStyle}
    overlayStyle={overlayStyle}
    contentStyle={contentStyle}
    buttonStyle={acceptButtonStyle}
    declineButtonStyle={declineButtonStyle}
    onAccept={() => {
      loadGoogleAnalytics().then(loaded => {
        if (loaded) {
          trackPageView(window.location.pathname + window.location.search)
        }
      })
    }}
  >
    <span style={headingStyle}>We value your privacy</span>
    <div>
      We use cookies to understand how the site is used and to keep improving
      your experience. You can change your mind at any time.
    </div>
  </CookieConsent>
)

export default AnalyticsConsent
